// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixWindow from 'wix-window';
import wixSite from 'wix-site';
$w.onReady(function () {
  //to make the plugin page width responsive
  var pluginWidth
  wixWindow.getBoundingRect()
  .then( (windowSizeInfo) => {
    let windowHeight = windowSizeInfo.window.height;
    let windowWidth = windowSizeInfo.window.width;
    pluginWidth = windowWidth - 60;
    //BE SURE TO RENAME THE WIX ELEMENT "#vboPlugin"
    $w('#vboPlugin').setAttribute("width", pluginWidth);
  })
  $w('#vboPlugin').expand()
});